module.exports = __webpack_public_path__ + "static/img/COC2023-26.6a667b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-26.png
// module id = yQLC
// module chunks = 0